import { useMutation } from "@tanstack/react-query";
import { analyzeSymptom } from "../api/analyzeSymptom";
import { toast } from "sonner";

export function useAnalyzeSymptom() {
  const mutation = useMutation({
    mutationFn: analyzeSymptom,
    onError: () => {
      toast.error("El asistente inteligente no está disponible en este momento");
    },
  });

  return {
    analyze: mutation.mutateAsync,
    isLoading: mutation.isPending,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  };
}